// Bakery hours are rendered server-side from the location metaobjects (synced from Yext by the
// levain-hours-sync worker). Shopify can serve a cached page past midnight and renders in the
// store's Eastern time zone, so this re-picks "today" in each bakery's own time zone and applies
// any holiday hours in the coming week. It only reads the data-location-hours JSON on the page;
// no network requests.
(function () {
  const formatters = {};

  function dateInZone(date, timeZone) {
    formatters[timeZone] ||= new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long',
    });
    const parts = Object.fromEntries(formatters[timeZone].formatToParts(date).map((part) => [part.type, part.value]));
    return { iso: `${parts.year}-${parts.month}-${parts.day}`, weekday: parts.weekday.toLowerCase() };
  }

  function applyHours(container) {
    let data;
    try {
      data = JSON.parse(container.dataset.locationHours);
    } catch (error) {
      return;
    }
    const special = new Map((data.special || []).map((entry) => [entry.date, entry.hours]));
    const now = Date.now();

    for (let offset = 0; offset < 7; offset++) {
      const { iso, weekday } = dateInZone(new Date(now + offset * 86400000), data.timeZone || 'America/New_York');
      const hours = special.get(iso) || data.weekly?.[weekday];
      if (!hours) continue;
      if (offset === 0) container.querySelectorAll('[data-hours-today]').forEach((el) => (el.textContent = hours));
      container.querySelectorAll(`[data-hours-day="${weekday}"]`).forEach((el) => (el.textContent = hours));
    }
  }

  document.querySelectorAll('[data-location-hours]').forEach(applyHours);
})();
